import { createIcon } from "@chakra-ui/react";

export const Play = createIcon({
  displayName: "Play",
  viewBox: "0 0 24 24",
  path: [
    <g transform="translate(4, 4)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95 1.219a1.496 1.496 0 0 0-1.516-.029 1.503 1.503 0 0 0-.766 1.31v11c0 .544.294 1.044.766 1.31a1.503 1.503 0 0 0 1.515-.029l9-5.5a1.5 1.5 0 0 0 0-2.563l-9-5.5z"
      />
    </g>
  ],
  defaultProps: {
    "aria-label": "A play"
  }
});
